/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_EventsInputs */

const cs_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const sk_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akcie`)
};

const en_nav_events = /** @type {(inputs: Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Nav_EventsInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_events = /** @type {((inputs?: Nav_EventsInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_EventsInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_events(inputs)
	if (locale === "sk") return sk_nav_events(inputs)
	return en_nav_events(inputs)
});